import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChevronsLeft, ChevronsRight, LucideAngularModule, Pencil, Trash2, Upload } from 'lucide-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { CatalogoProdutosComponent } from './catalogo-produtos.component';
import { CatalogoProdutosRoutingModule } from './catalogo-produtos-routing.module';
import { CatalogEmptyStateComponent } from './components/catalog-empty-state/catalog-empty-state.component';
import { CatalogProductDialogComponent } from './components/catalog-product-dialog/catalog-product-dialog.component';
import { CompanySidebarComponent } from './components/company-sidebar/company-sidebar.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    CatalogoProdutosRoutingModule,
    LucideAngularModule.pick({ Pencil, Trash2, Upload, ChevronsLeft, ChevronsRight })
  ],
  declarations: [
    CatalogoProdutosComponent,
    CatalogEmptyStateComponent,
    CatalogProductDialogComponent,
    CompanySidebarComponent
  ]
})
export class CatalogoProdutosModule {}
